import { Stack } from "@mui/material";
import { useAppSelector } from "../../../redux-store/hooks";
import { PlacesCard } from "./places-card";
import React, { FC } from "react";

interface PlaceViewerProps {
    places: string[];
    selectedPlace: string;
    setSelectedPlace: (place: string) => void;
}

const PlacesViewer:FC<PlaceViewerProps> = ({places, selectedPlace, setSelectedPlace}) => {
    return (
        <Stack flexDirection={"column"}>
            <PlacesCard key={"All"} onClick={() => setSelectedPlace("All")}
                    placeName={"All"} selectedPlace={selectedPlace} />
            {places?.map(p => (
                <PlacesCard key={p} onClick={() => setSelectedPlace(p)}
                    placeName={p} selectedPlace={selectedPlace} />
            ))}
        </Stack>
    )
}

export { PlacesViewer };
